import styled from "styled-components";


export const CardBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  width: 100%;
  margin: 10px;
  color: #7c7e80;
`;

export const CardTitle = styled.div`
  padding: 10px 15px 0 15px;
  font-size: 11pt;
  text-align: center;
  margin-bottom: 0.75rem;
`;

export const CardSubTitle = styled.div`
  font-size: 9pt;
`;

export const CardContent = styled.div`
  padding: 0px 15px 10px 15px;
  font-weight: bold;
  font-size: 14pt;
  text-align: center;
`;

export const CardBadge = styled.span`
  margin-left: 10px;
  color: #FFF;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: 
    color 0.15s ease-in-out, 
    background-color 0.15s ease-in-out, 
    border-color 0.15s ease-in-out, 
    box-shadow 0.15s ease-in-out;
`;